import SkyMapContainer from "./SkyMapContainer";

export default SkyMapContainer;